<template lang="pug">
  span Component
</template>

<script type="text/javascript">
export default {
  name: 'CategoryEntry',
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/CategoryEntry.vue